(function($) {
	$(document).ready(function(){
		!function(a){"function"==typeof define&&define.amd?define(["jquery"],function(b){return a(b)}):"object"==typeof module&&"object"==typeof module.exports?module.exports=a(require("jquery")):a(window.jQuery)}(function(a){"use strict";function b(a){void 0===a&&(a=window.navigator.userAgent),a=a.toLowerCase();var b=/(edge)\/([\w.]+)/.exec(a)||/(opr)[\/]([\w.]+)/.exec(a)||/(chrome)[ \/]([\w.]+)/.exec(a)||/(iemobile)[\/]([\w.]+)/.exec(a)||/(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a)||/(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(a)||/(webkit)[ \/]([\w.]+)/.exec(a)||/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a)||/(msie) ([\w.]+)/.exec(a)||a.indexOf("trident")>=0&&/(rv)(?::| )([\w.]+)/.exec(a)||a.indexOf("compatible")<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)||[],c=/(ipad)/.exec(a)||/(ipod)/.exec(a)||/(windows phone)/.exec(a)||/(iphone)/.exec(a)||/(kindle)/.exec(a)||/(silk)/.exec(a)||/(android)/.exec(a)||/(win)/.exec(a)||/(mac)/.exec(a)||/(linux)/.exec(a)||/(cros)/.exec(a)||/(playbook)/.exec(a)||/(bb)/.exec(a)||/(blackberry)/.exec(a)||[],d={},e={browser:b[5]||b[3]||b[1]||"",version:b[2]||b[4]||"0",versionNumber:b[4]||b[2]||"0",platform:c[0]||""};if(e.browser&&(d[e.browser]=!0,d.version=e.version,d.versionNumber=parseInt(e.versionNumber,10)),e.platform&&(d[e.platform]=!0),(d.android||d.bb||d.blackberry||d.ipad||d.iphone||d.ipod||d.kindle||d.playbook||d.silk||d["windows phone"])&&(d.mobile=!0),(d.cros||d.mac||d.linux||d.win)&&(d.desktop=!0),(d.chrome||d.opr||d.safari)&&(d.webkit=!0),d.rv||d.iemobile){var f="msie";e.browser=f,d[f]=!0}if(d.edge){delete d.edge;var g="msedge";e.browser=g,d[g]=!0}if(d.safari&&d.blackberry){var h="blackberry";e.browser=h,d[h]=!0}if(d.safari&&d.playbook){var i="playbook";e.browser=i,d[i]=!0}if(d.bb){var j="blackberry";e.browser=j,d[j]=!0}if(d.opr){var k="opera";e.browser=k,d[k]=!0}if(d.safari&&d.android){var l="android";e.browser=l,d[l]=!0}if(d.safari&&d.kindle){var m="kindle";e.browser=m,d[m]=!0}if(d.safari&&d.silk){var n="silk";e.browser=n,d[n]=!0}return d.name=e.browser,d.platform=e.platform,d}return window.jQBrowser=b(window.navigator.userAgent),window.jQBrowser.uaMatch=b,a&&(a.browser=window.jQBrowser),window.jQBrowser});
		const browser = $.browser;

		const addClassToRoot = classes => $('html').addClass(classes);
		
		addClassToRoot((browser.mobile === true) ? 'mobile' : 'desktop');

		if(browser.msie || browser.webkit || browser.mozilla || browser.msedge){
			if (browser.msie) {
				addClassToRoot(`ie v-${browser.versionNumber}`)
			}
			if (browser.chrome) {
				addClassToRoot(`chrome v-${browser.versionNumber}`)
			}
			if (browser.msedge){
				addClassToRoot(`edge v-${browser.versionNumber}`)
			}
		}



		(function heroSlides() {
			const $heroSlider = $('.showcases');
			const $firstSlide = $heroSlider.find('.slide:first');
			const $firstSlideAnimation = $firstSlide.find("[data-animation]");

			$heroSlider.slick({
				autoplay: true,
				autoplaySpeed: 5000,
				dots: true,
				arrows: false,
				speed: 1000,
				// infinite: false,
				rtl: true,
				// pauseOnHover: false,
				// pauseOnFocus: false,
			});

			function slideAnimation(elem) {
				const animEndEv = 'webkitAnimationEnd animationend';
				elem.each(function() {
					const $this = $(this);
					const $animationType = $this.data('animation');

					$this.css('opacity', '1').addClass($animationType).on(animEndEv, () => {
						$this.removeClass($animationType);
					});
				});
			}

			$heroSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				const slide = $(slick.$slides.get(currentSlide));
				const $caption = slide.find("[data-animation]").css('opacity', '0');
			});

			$heroSlider.on('afterChange', (event, slick, currentSlide, nextSlide) => {
				const slide = $(slick.$slides.get(currentSlide));
				const $caption = slide.find("[data-animation]");
				slideAnimation($caption);
			});

			slideAnimation($firstSlideAnimation);
			
			// setInterval(() => {
			// 	$heroSlider.slick('slickNext');
			// }, 4000);
		})();

		$('.icecream-slider').slick({
			centerMode: true,
			centerPadding: '280px',
			slidesToShow: 1,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 5000,
			rtl: false,
			responsive: [
				{
					breakpoint: 800,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: '0px',
						slidesToShow: 2
					}
				},
				{
					breakpoint: 540,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: '0px',
						slidesToShow: 1
					}
				}
			]
		});

		if (!browser.msedge){
			console.log(browser.msie);
			// if (browser.msie === false) {
				console.log(browser.msie)
				$('.js-tilt').tilt({
					glare: true,
					maxGlare: .75,
					maxTilt: 8,
					// scale: 1.05
				});
				$('.js-tilt-showcase').tilt({
					glare: true,
					maxGlare: 0.75,
					maxTilt: 4
				});

				$('.js-tilt-logo').tilt({
					glare: false,
					scale: 1.1,
					// maxTilt: 4
				});
			// }
		}

		/**
		 * .animate element in a screen view?
		 */
		$(function inView() {
			const $el = $('.animate');
			if ($.browser.mobile) {
				$(window).on('scroll', function () {
					scrollInView();
				});
				scrollInView();

				function scrollInView() {
					window.requestAnimationFrame(() => {
						const scrollTop = $(window).scrollTop();
						const windowHeight = $(window).outerHeight();
						const fullHeight = scrollTop + windowHeight;
						$.each($el, function() {
							const t = $(this);
							const height = t.outerHeight();
							const offsetTop = t.offset().top;
							(offsetTop + height >= scrollTop - 50) && (offsetTop <= fullHeight) ? t.addClass(t.data('animation')) : false
							// (offsetTop + height >= scrollTop - 50) && (offsetTop <= fullHeight) ? t.addClass(t.data('animation')) : t.removeClass(t.data('animation'))
						});
					});
				};
			} else {
				$el.addClass('in-view')
			}
		});

		const $hamburger = $('.hamburger--icon');
		$hamburger.click(function(){
			if ($hamburger.hasClass('active')) {
				$hamburger.removeClass('active');
				$('.responsive-menu').slideUp("slow");
			} else {
				$hamburger.addClass('active');
				$('.responsive-menu').slideDown("slow");
			}
		});

		if ($('#map').length > 0) {
			contactMap();
		}
	});
})(jQuery);
function contactMap() {
	let map;
	let ObjID;
	let mapOptions;

	const googleMarker = [];
	const googleAddMarker = (center, map, type) => {
		// Retina support
		let requireImagePrefix = '';
		const devicePixelRatio = (window.devicePixelRatio===undefined?1:window.devicePixelRatio);

		if (devicePixelRatio > 1) {
			requireImagePrefix = '@2x';
		}

		const pinImage = {
			url: `./build/images/${type}${requireImagePrefix}.png`,
			scaledSize: new google.maps.Size(48, 63),
			// anchor: new google.maps.Point(0, 64)
		};

		const marker = new google.maps.Marker({
			position: center,
			map: map,
			icon: pinImage,
			animation: google.maps.Animation.DROP,
			optimized: true
		});

		marker.addListener('click', function() {
			$('.input').removeClass('error');
			$('.hint').remove();
			$('.popover').addClass('show');
			map.panTo(this.position);
		});

		googleMarker.push(marker);
	};

	function initMap() {
		let LatLang = ObjID.data('latlang').split(','),
			Lat = parseFloat(LatLang[0]),
			Lang = parseFloat(LatLang[1]);

		mapOptions = {
			zoom: 15,
			disableDefaultUI: true,
			minZoom: 12,
			maxZoom: 20,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.LARGE,
				position: google.maps.ControlPosition.LEFT_TOP
			},
			styles: [
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#7c93a3"
						},
						{
							"lightness": "-10"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "geometry",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "administrative.country",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#a0a4a5"
						}
					]
				},
				{
					"featureType": "administrative.province",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#62838e"
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#dde3e3"
						}
					]
				},
				{
					"featureType": "landscape.man_made",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#3f4a51"
						},
						{
							"weight": "0.30"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "simplified"
						}
					]
				},
				{
					"featureType": "poi.attraction",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.business",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.government",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "poi.place_of_worship",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.school",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "poi.sports_complex",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "all",
					"stylers": [
						{
							"saturation": "-100"
						},
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#bbcacf"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"lightness": "0"
						},
						{
							"color": "#bbcacf"
						},
						{
							"weight": "0.50"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text",
					"stylers": [
						{
							"visibility": "on"
						}
					]
				},
				{
					"featureType": "road.highway.controlled_access",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.highway.controlled_access",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#a9b4b8"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.icon",
					"stylers": [
						{
							"invert_lightness": true
						},
						{
							"saturation": "-7"
						},
						{
							"lightness": "3"
						},
						{
							"gamma": "1.80"
						},
						{
							"weight": "0.01"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "all",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#a3c7df"
						}
					]
				}
			],
			scrollwheel: false,
			scaleControl: false,
			zoomControl: true,
			disableDoubleClickZoom: true,
			center: {
				lat: Lat,
				lng: Lang
			},
		};
		map = new google.maps.Map(ObjID.get(0), mapOptions);
	}

	$.getScript('https://maps.googleapis.com/maps/api/js?language=fa&key=AIzaSyDv4q05lZ1lBiYfQ2X75UTzRjAmWxZbAgk', function() {
		$('.map-init').each(function() {
			ObjID = $(this);
			initMap();
			googleAddMarker(mapOptions.center, map, 'marker');
		});
	});
};
